var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("demo.header")))]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.error,
            expression: "!error"
          }
        ],
        staticClass: "ct-card"
      },
      [
        _c("section", [
          _c("h3", [_vm._v(_vm._s(_vm.$t("demo.information.header")))]),
          _vm._v(" "),
          _c("p", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("demo.information.text")))
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "text-center",
            domProps: { innerHTML: _vm._s(_vm.$t("demo.support.text")) }
          })
        ]),
        _vm._v(" "),
        _vm.showCreateButton()
          ? _c("section", { staticClass: "ct-action" }, [
              _c(
                "div",
                [
                  _c("select-input", {
                    attrs: {
                      config: {
                        translationKey: "demo.template.label",
                        required: true,
                        id: "template-select",
                        prefix: "demo.template"
                      },
                      preSelect: "freikirche",
                      options: _vm.options.templates,
                      "input-model": _vm.template
                    },
                    on: {
                      "update:inputModel": function($event) {
                        _vm.template = $event
                      },
                      "update:input-model": function($event) {
                        _vm.template = $event
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "ct-input-element" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg btn-block",
                    attrs: {
                      disabled: _vm.template === null,
                      type: "button",
                      id: "demo-create-btn"
                    },
                    on: {
                      click: function($event) {
                        return _vm.createDemo()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("demo.create.button")) +
                        "\n                "
                    )
                  ]
                )
              ])
            ])
          : _vm.showChurchToolsButton()
          ? _c("section", { staticClass: "ct-action" }, [
              _c("div", { staticClass: "ct-input-element" }, [
                _vm.url && !_vm.isLoading
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-primary btn-lg btn-block",
                        attrs: {
                          id: "demo-link",
                          href: _vm.url,
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("demo.churchtools.button")))]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ct-input-element" }, [
                _c("div", { staticClass: "ct-hint" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("demo.churchtools.text")) +
                      ":"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.url } }, [
                    _vm._v(_vm._s(_vm.url))
                  ])
                ])
              ])
            ])
          : _c(
              "section",
              { staticClass: "ct-action" },
              [
                _c("Spinner"),
                _vm._v(" "),
                _c("div", { staticClass: "ct-input-element" }, [
                  _c("div", { staticClass: "ct-hint" }, [
                    _vm._v(_vm._s(_vm.$t("demo.create.spinner")))
                  ])
                ])
              ],
              1
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.error,
            expression: "error"
          }
        ],
        staticClass: "ct-card"
      },
      [
        _c("section", [
          _c("h3", [_vm._v(_vm._s(_vm.$t("demo.error.header")))]),
          _vm._v(" "),
          _c("p", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("demo.error.text")))
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "ct-action" }, [
          _c("div", { staticClass: "ct-input-element" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg btn-block",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.reload()
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("demo.error.reload")) +
                    "\n                "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ct-input-element" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-secondary btn-lg btn-block",
                attrs: { href: "https://contact.church.tools" }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("demo.support.contact")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f18eaa8", { render: render, staticRenderFns: staticRenderFns })
  }
}